module.exports = __webpack_public_path__ + "img/vipevent_sensitive_icon@2x.409906bd.png";